import React, { useState } from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import mixpanel from "mixpanel-browser";

import { useOutsideClickHook } from "utils/outsideClick";
import { useStateSelector } from "utils/field";

import { change } from "store/root/actions";

import VersionEntryDropdown from "./VersionEntryDropdown";

import ThreeDots from "assets/images/icons/JSX/ThreeDots";

import classes from "./styles.module.scss";

const VersionEntry = ({ name = "", status = "", date = "", closeDrawer, ...props }) => {
    const dispatch = useDispatch();

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const dropdownRef = useOutsideClickHook(() => setIsDropdownOpen(false));

    const { base = {} } = useStateSelector("upgrades.packages");
    const modelId = useStateSelector("model.modelId") || "";
    const uid = useStateSelector("user.uid") || "";

    const onRestore = () => {
        const { modelData = {}, upgradePackage = {} } = props;

        dispatch(change("model.modelData", modelData));
        dispatch(change("upgrades.packages", { base, ...upgradePackage }));

        mixpanel.track("Version History Revert", {
            ModelId: modelId,
            UserId: uid,
            VersionDate: date,
        });

        setIsDropdownOpen(false);
        closeDrawer();
    };

    return (
        <div className={classes.versionEntryContainer}>
            <div className={classes.versionEntryContent} ref={dropdownRef}>
                <div className={classes.versionEntryContentHeader}>
                    <div className={classes.versionEntryPoint} />
                    <span className={classes.versionEntryContentHeaderName}>
                        Autosave {moment(date).format("MMM D")}
                    </span>
                    {/* TODO: for the future */}
                    {/* <span>{status ?? ""}</span> */}
                    <ThreeDots
                        className={classes.versionEntryContentHeaderDots}
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    />
                    <VersionEntryDropdown
                        open={isDropdownOpen}
                        close={() => setIsDropdownOpen(false)}
                        onRestore={onRestore}
                    />
                </div>
                <span className={classes.versionEntryContentDate}>{moment(date).format("MMM D, YYYY, h:mm A")}</span>
            </div>
        </div>
    );
};

export default VersionEntry;
